export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-rdio-444b81342bb64a47fdf80bfc9470a3a8.svg";